import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "src/app/App";
import "./index.css";

// Providers, the data router, and its basename (from runtime config) all
// live inside src/app/{providers,router,App}.tsx now — this file is just
// the DOM mount point.
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
